import { createSelector } from 'reselect';

export const userSelector = (state) => state.user;

export const selectUser = createSelector(userSelector, (state) => state.user);

export const selectUserTokens = createSelector(
  userSelector,
  (state) => state.tokens,
);

export const selectUserError = createSelector(
  userSelector,
  (state) => state.error,
);

export const selectLogonUid = createSelector(
  userSelector,
  (state) => state.logonUid,
);

export const selectBasicAccount = createSelector(
  userSelector,
  (state) => state.basicAccount,
);
